import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import SvgLineDirectiveController from "./SvgLineDirectiveController";

import "./SvgLine.html";

export default class SvgLineDirective implements IDirective {
    public bindToController = {
        create: "=?",
        editable: "=?",
        editing: "=?",
        onEditing: "&?",
        points: "=mmSvgLine",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    public templateNamespace: "svg";

    public templateUrl = "/App/Modules/Gui/Directives/SvgLine/SvgLine.html";

    constructor() {
        this.controller = SvgLineDirectiveController;
    }
}

module("mmGui").directive("mmSvgLine", () => new SvgLineDirective());
